module.exports = __webpack_public_path__ + "static/img/图层62.58cd3e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层62.png
// module id = 76Yq
// module chunks = 0